import ConfigParameter, { gettext } from "../ConfigParameter";

export default class Options extends ConfigParameter {

    constructor() {
        super('options', 'options', gettext('Options'), 'mainConfig', () => [gettext("Option 1"), gettext("Option 2")]);
    }

}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Options.js